// assets/afterpay.js
(function () {
  const section = document.querySelector('.afterpay-section');
  if (!section) return;

  const placement = section.querySelector('afterpay-placement');
  if (!placement) return;

  function applyStyles() {
    if (!placement.shadowRoot) return;

    const para = placement.shadowRoot.querySelector('.afterpay-paragraph');
    if (para) {
      para.style.cssText = 'text-align: center !important; max-width: 100%; background: #F4F4F4; padding-top: 6px; padding-bottom: 6px; border-radius: 10px; font-size: 12px;';
    }

    const showMore = placement.shadowRoot.querySelector('.afterpay-logo-link [data-modal-open], .afterpay-info-link, button.afterpay-more-info, a.afterpay-more-info');
    if (showMore) {
      showMore.style.textDecoration = 'underline';
      showMore.style.cursor = 'pointer';
    }

    // Inject a <style> into the shadow root to target logo selectors
    if (!placement.shadowRoot.querySelector('#olay-afterpay-styles')) {
      const style = document.createElement('style');
      style.id = 'olay-afterpay-styles';
      style.textContent = `
        .afterpay-logo.logo-cashappafterpay,
        .afterpay-logo.logo-cashappafterpay svg {
          height: 10px !important;
          width: auto !important;
        }
      `;
      placement.shadowRoot.appendChild(style);
    }
  }

  function applyAlignment() {
    if (!placement.shadowRoot) return;
    applyStyles();
    // Watch for async renders inside the shadow root
    const observer = new MutationObserver(applyStyles);
    observer.observe(placement.shadowRoot, { childList: true, subtree: true });
  }

  // Load present-afterpay.js first (registers the placement component)
  const presentScript = document.createElement('script');
  presentScript.type = 'text/javascript';
  presentScript.src = 'https://static-us.afterpay.com/javascript/present-afterpay.js';
  document.head.appendChild(presentScript);

  // Load afterpay-1.x.js (activates the widget)
  const widgetScript = document.createElement('script');
  widgetScript.src = 'https://js.afterpay.com/afterpay-1.x.js';
  widgetScript.dataset.min = '50.00';   // edit this to change the lower bound
  widgetScript.dataset.max = '1000.00'; // edit this to change the upper bound
  widgetScript.onload = function () {
    applyAlignment();
    window.addEventListener('resize', applyAlignment);
  };
  document.head.appendChild(widgetScript);

})();
